import {
  Box,
  Button,
  Hidden,
  IconButton,
  makeStyles,
  useTheme,
  useMediaQuery,
  Grid,
  Drawer,
  ButtonGroup,
  Container,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { CgMenuGridR } from "react-icons/cg";
import {
  Profile,
  Products,
  Earnings,
  Settings,
  Orders,
  Notifications,
  AdverBooks,
  ChangePaymentMethod
} from "./components";
import tabs from "./tabs";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: "220px",
    height: "100%",
    backgroundColor: "black",
    color: "white",
  },
  tabBtn: {
    color: "black",
    // backgroundColor: 'red',
    display: "flex",
    justifyContent: "flex-start",
    textAlign: "left",
    padding: "10px",
  },
  tabs: {
    marginTop: "30px",
  },
  drawerBtn: {
    color: "white",
    display: "flex",
    justifyContent: "flex-start",
    textAlign: "left",
    padding: "10px",
  },
  activeTabBtn: {
    backgroundColor: theme.palette.primary.main,
    display: "flex",
    justifyContent: "flex-start",
    padding: "10px",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
  },
}));

function Author() {
  const [openTab, setOpenTab] = useState(false);
  const state = useSelector((state) => state.auth);
  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const location = useLocation();
  const [tabPanelIndex, setTabPanelIndex] = useState(0);
  const toggleTabView = () => {
    setOpenTab(!openTab);
  };
  const handleTabOpen = () => {
    setOpenTab(true);
  };
  const handleTabClose = () => {
    setOpenTab(false);
  };
  const activeTabFunc = (()=>{
    if (location?.state && location?.state?.activeTab) {
      setTabPanelIndex(location.state.activeTab);
    }
  })

  useEffect(() => {
    activeTabFunc();
  }, [location?.state?.activeTab]);
  return (
    <div>
      <Box display="flex" justifyContent="flex-end" alignItems="center">
        {/* <h2>Dashboard</h2> */}
        <Hidden only={["lg", "xl", "md"]}>
          <IconButton
            onClick={toggleTabView}
            style={{
              backgroundColor: theme.palette.primary.main,
              marginTop: "-25px",
            }}
          >
            <CgMenuGridR />
          </IconButton>
        </Hidden>
      </Box>
      <Hidden only={["lg", "xl", "md"]}>
        <Drawer
          classes={{ paper: classes.drawer, modal: classes.drawerModal }}
          anchor="left"
          open={isDesktop ? true : openTab}
          variant={isDesktop ? "permanent" : "temporary"}
          onClose={handleTabClose}
        >
          {tabs.map((tab, index) => (
            <Button
              startIcon={
                tab.panel === tabPanelIndex ? tab.activeIcon : tab.icon
              }
              key={index}
              className={
                tab.panel === tabPanelIndex
                  ? classes.activeTabBtn
                  : classes.drawerBtn
              }
              onClick={() => {
                setTabPanelIndex(tab.panel);
                handleTabClose();
              }}
              align="left"
              fullWidth
            >
              {tab.name}
            </Button>
          ))}
        </Drawer>
      </Hidden>
      <Container maxWidth="xl">
        <Grid container spacing={5}>
          <Grid item xs={12} md={3} lg={2}>
            <Hidden only={["xs", "sm"]}>
              <div className={classes.tabs}>
                <ButtonGroup orientation="vertical" fullWidth>
                  {tabs.map((tab, index) => (
                    <Button
                      startIcon={
                        tab.panel === tabPanelIndex ? tab.activeIcon : tab.icon
                      }
                      key={index}
                      className={
                        tab.panel === tabPanelIndex
                          ? classes.activeTabBtn
                          : classes.tabBtn
                      }
                      onClick={() => setTabPanelIndex(tab.panel)}
                      align="left"
                      fullWidth
                    >
                      {tab.name}
                    </Button>
                  ))}
                </ButtonGroup>
              </div>
            </Hidden>
          </Grid>
          <Grid item xs={12} md={9} lg={10}>
            {tabPanelIndex === 0 && <Profile user={state.currentUser} />}
            {tabPanelIndex === 1 && (
              <Products books={state.products} user={state.currentUser} />
            )}
            {tabPanelIndex === 2 && <AdverBooks user={state.currentUser} />}

            {tabPanelIndex === 3 && <Earnings earnings={state.earnings} />}
            {tabPanelIndex === 4 && <Settings user={state.currentUser} />}
            {tabPanelIndex === 5 && <Orders orders={state.orders} />}
            {tabPanelIndex === 6 && (
              <Notifications userId={state.currentUser.author._id} />
            )}
            {tabPanelIndex === 7 && (
              <ChangePaymentMethod  />
            )}
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

export default Author;
